// extracted by mini-css-extract-plugin
export default {"main":"AuditLogs_main__6ywmP"};